import { Dispatch, SetStateAction } from "react";
import { BodyText, FormContainer } from "./CustomerInfo.styled";
import InfoForm from "./InfoForm";

interface CustomerInfoProps {
  handleSubmit: ({ paymentId, postalCode }: { paymentId: string; postalCode: string }) => void;
  intentToken: string;
  handleError: Dispatch<SetStateAction<string>>;
}
const CustomerInfo = ({ handleSubmit, handleError, intentToken }: CustomerInfoProps) => (
  <div data-testid="transfer-complete-form">
    <h3>Pending Account Transfer</h3>
    <BodyText>
      {
        "Before being able to access your Mirror, you will need to add a valid credit card to your account, which will be used to process monthly Membership payments ($39/mo.)"
      }
    </BodyText>
    <FormContainer>
      <InfoForm intentToken={intentToken} handleSubmit={handleSubmit} handleError={handleError} />
    </FormContainer>
  </div>
);

export default CustomerInfo;
